/**
 * NOTE: `cb` is intentionally left loosely typed. Typing it as
 * `(...args: TArgs) => void` and returning `(...args: TArgs) => void` is the
 * honest signature, but it surfaces a pre-existing type mismatch at the
 * `updateMultiGroupBlockAnnotations` call sites (they pass
 * `activeDocument?.id || 0` — a `string | 0` — for a `documentId: string`
 * parameter). Fixing that belongs with those call sites, not here.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const throttle = (cb: (...args: any) => void, delay: number) => {
  let wait = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...args: any) => {
    if (wait) {
      return;
    }

    cb(...args);
    wait = true;
    setTimeout(() => {
      wait = false;
    }, delay);
  };
};
